import { inject, Injectable } from '@angular/core';

import type { ThemeType } from '@evc/web-components';
import { ThemeService } from '@evc/web-components';

import { PlatformConfigService } from '../config/config.service';

const THEME_CACHE_KEY = 'evcnt_user_theme';

@Injectable({ providedIn: 'root' })
export class ThemePreferenceService {
  readonly #themeService = inject(ThemeService);
  readonly #platformConfigService = inject(PlatformConfigService);

  constructor() {
    const cachedTheme = this.#platformConfigService.get(THEME_CACHE_KEY);

    if (cachedTheme === 'light' || cachedTheme === 'dark' || cachedTheme === 'auto') {
      this.#themeService.setTheme(cachedTheme);
    }
  }

  selectTheme(theme: Exclude<ThemeType, 'ims'>): void {
    this.#themeService.setTheme(theme);
    this.#platformConfigService.set(THEME_CACHE_KEY, theme, true);
  }
}
